<template lang="html">
  <v-form ref="form" lazy-validation>
    <v-card class="card-size">
      <v-card-title>
        {{ ehEdicao ? $t('title.editar_concorrente') : $t('title.cadastrar_novo_concorrente') }}
      </v-card-title>
      <v-container grid-list-xl fluid>
        <v-row>
          <v-col cols="12">
            <v-text-field
              id="concorrente_codigo"
              name="concorrente_codigo"
              v-model="concorrente.idExterno"
              class="Form-text__invalid"
              :label="`${$tc('label.codigo', 1)} *`"
              :counter="80"
              maxlength="80"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              id="concorrente_nome"
              name="concorrente_nome"
              v-model="concorrente.nomConcorrente"
              class="Form-text__invalid"
              :label="`${$tc('label.nome', 1)} *`"
              :counter="80"
              maxlength="80"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel">{{ $t('label.cancelar') }}</v-btn>
        <v-btn @click.native="openSaveDialog" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      @agree="save()">
    </confirm>
  </v-form>
</template>

<script>
import Confirm from '../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'ConcorrenteForm',
  data() {
    return {
      concorrenteResources: this.$api.concorrente(this.$resource),

      concorrente: {},
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
      dialog: {
        content: '',
      },
    };
  },
  watch: {
  },
  components: {
    Confirm,
  },
  methods: {
    cancel() {
      this.limparFormulario();
    },
    editar(concorrente) {
      this.concorrente = { ...concorrente };
    },
    limparFormulario() {
      this.concorrente = {};
      this.$refs.form.reset();
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save() {
      let salvarOuAtualizar;
      let inclusao = true;

      if (this.concorrente.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.concorrenteResources.atualizar(this.concorrente);
      } else {
        salvarOuAtualizar = this.concorrenteResources.gravar(this.concorrente);
      }

      salvarOuAtualizar
        .then(() => this.limparFormulario())
        .then(() => this.$toast(
          this.$t(
            inclusao
              ? 'message.adicionado_confira_tabela'
              : 'message.atualizado_confira_tabela',
          ),
        ))
        .then(() => {
          this.$emit('FORMULARIO_CADASTRO_CONCORRENTE_SALVAR', this.concorrente, this.clearForm);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  computed: {
    ehEdicao() {
      return this.concorrente.id;
    },
  },
  mounted() {

  },
};
</script>
